// Fired after any saved change (not a read); the setup guide reloads its check marks.
export const DATA_SAVED_EVENT = 'cwm:data-saved';

export function notifyDataSaved() {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(DATA_SAVED_EVENT));
}
